import React from 'react';
import {Card, Typography} from 'antd';

const {Title} = Typography;

export default function LegalDocument({document}) {
    return (
        <main style={{maxWidth: '900px', margin: '0 auto', padding: '2rem 1rem'}}>
            <Card>
                <article>
                    <Title level={1}>{document.title}</Title>
                    <p><em>{document.publicationNote}</em></p>
                    <p>{document.intro}</p>
                    {document.sections.map(section => (
                        <section key={section.heading}>
                            <h2>{section.heading}</h2>
                            {(section.paragraphs || []).map(paragraph => <p key={paragraph}>{paragraph}</p>)}
                            {section.items && <ul>{section.items.map(item => <li key={item}>{item}</li>)}</ul>}
                        </section>
                    ))}
                </article>
            </Card>
        </main>
    );
}
